import script from "./orderStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./orderStatistics.vue?vue&type=script&setup=true&lang=js"

import "./orderStatistics.vue?vue&type=style&index=0&id=32894cdd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32894cdd"]])

export default __exports__